
export const MARKDOWN_PAGES = [
    'Anensky_vrch',
    'Bavory',
    'bioticke_mapovani',
    'Brezi',
    'Brnenska',
    'Bzenec',
    'Culisty',
    'dendrogram',
    'Dily_za_zahradou',
    'Dlouha_hora',
    'Dlouhe_dily',
    'Dolni_hory',
    'Domanin',
    'Fladnicka',
    'Frisaky',
    'geneticka_analyza',
    'Hajky',
    'Hasneky',
    'Havraniky',
    'Hinteraly',
    'Hnanice',
    'Horni_ctvrte',
    'Horni_hory',
    'Horni_hory_Straznice',
    'Humna',
    'Hurka',
    'Jizni_svahy',
    'Jizni_svahy_Uvaly',
    'Kacisdorfske_pole',
    'Kamenne_hory',
    'Kienberg',
    'Knezi_hora',
    'Knizeci_vrch',
    'Knizeci_vyhlidka',
    'Konice',
    'Kravi_hora',
    'Kravi_hora_Konice',
    'Kravi_hora_Zahradky',
    'Krefty',
    'Lisci_vrch',
    'Maliny',
    'Mariansky_kopec',
    'Mikrosatelitni_lokus',
    'Mikulov',
    'mikulovska',
    'Milovicka',
    'Moravsky_Zizkov',
    'Nad_mlynem',
    'Nad_peklem',
    'Nad_sklepy',
    'Na_vinici',
    'Nova_hora',
    'Novosady',
    'Novosady_zadni',
    'Novy_Saldorf',
    'Obecni',
    'Obory',
    'Odrudova_skladba',
    'Orechova_hora',
    'o_aplikaci',
    'Pansky_kopec',
    'PCR',
    'Peklo',
    'Petrov',
    'PIWI',
    'Podkovne',
    'Podmoli',
    'Pod_Belegrady',
    'Pod_lesem',
    'Pod_Muslovem',
    'Pod_Palavou',
    'Pod_Reistnou',
    'Pod_Slunecni_horou',
    'Pod_strani',
    'Pod_Sv_kopeckemI',
    'Pod_Sv_kopeckemII',
    'Pod_Valtickou',
    'Popice',
    'Pouzite_literarni_zdroje',
    'Predni_hora',
    'Prostredni_hory',
    'Puste',
    'Ruzene',
    'Ruzene_Petrov',
    'Ruzova',
    'Sacny',
    'Sahary',
    'Satov',
    'Sibenicni_vrch',
    'Siroka_hora',
    'Skalky',
    'Skalky_Havraniky',
    'Sliny',
    'slovacka',
    'Slovenske',
    'Slunecna',
    'Sobes',
    'Sonnenberg',
    'SSR',
    'Stara_hora',
    'Stara_hora_Zizkov',
    'Stare_hory',
    'Stare_hory_Uvaly',
    'Stare_vinice',
    'Stary_hrad',
    'Stracinky',
    'Straznice',
    'Straznicko',
    'Sudomerice',
    'Svarove',
    'Svata',
    'Teple',
    'Terroir',
    'Terasy_Krizovy_sklep',
    'Terasy_u_hranic',
    'Tmice',
    'Turold',
    'Typologie_objektu',
    'Uvaly',
    'U_bunkru',
    'U_Chlupa',
    'U_cihelny',
    'U_kaplicky',
    'U_rybnicka',
    'U_Sv_Anny',
    'Valtice',
    'Valticka',
    'Vapenky',
    'Velke_Bilovice',
    'velkopavlovicka',
    'Vesele',
    'vinarska_oblast_morava',
    'Vinohradka',
    'Vinohradky_Bilovice',
    'vinohradnicke_lisy',
    'vinohradnicke_stavby',
    'Zadni_hora',
    'Zadni_hora_Bilovice',
    'Za_cihelnou',
    'Za_humny',
    'Za_Turoldem',
    'Zerotiny',
    'znojemska'
]